// extracted by mini-css-extract-plugin
module.exports = {"root":"az_H-b","icon":"az_I-b"};